import React from 'react'
import PropTypes from 'prop-types'
import { Button, Text } from '@salesforce/retail-react-app/app/components/shared/ui'
import { useMultiStyleConfig } from '@chakra-ui/react'
import { ChevronRightIcon } from '../../../components/icons'

const DSSActionButton = ({ label, icon, testId, onClick }) => {
    const styles = useMultiStyleConfig('OrderDetailsDSS')

    return (
        <Button
            {...styles.dssActionButton}
            data-testid={testId}
            onClick={onClick}
        >
            <Text {...styles.dssActionButtonText}>
                {icon}
                <Text as="span">{label}</Text>
            </Text>

            <ChevronRightIcon boxSize="24px" />
        </Button>
    )
}

DSSActionButton.propTypes = {
    label: PropTypes.node.isRequired,
    icon: PropTypes.node,
    testId: PropTypes.string,
    onClick: PropTypes.func
}

export default DSSActionButton